<template>
    <div v-resized="resized" class="route-analyzer d-flex flex-column flex-md-row">
        <div class="spinner-wrapper" v-show="loading">
            <Spinner></Spinner>
        </div>

        <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            :filename="
                __('geofleet.analyzer.vehicle_activity_analisys') +
                ' ' +
                (truck.details.custom_id || truck.plate)
            "
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="html2Pdf"
        >
            <section class="mx-auto p-5" slot="pdf-content">
                <div class="row">
                    <div class="col-lg-6">
                        <!-- PDF Content Here -->
                        <h3 class="targa-f">{{ truck.details.custom_id || truck.plate }}</h3>

                        <div v-if="truck.details.custom_id" class="plate">
                            <small>{{ truck.plate }}</small>
                        </div>
                    </div>
                    <div class="col-lg-6 text-right">
                        <img
                            class="golia-logo img-fluid d-block ms-auto"
                            src="data:image/png;base64,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"
                        />
                    </div>
                </div>

                <img class="my-5 img-fluid" :src="screenshot" />

                <div class="print-recap">
                    <div class="title mb-4">
                        <i class="fa-solid fa-book"></i>&nbsp;{{ __('recap') }}
                    </div>

                    <div class="info" v-if="routeTimeline && routeTimeline.recap">
                        <div>
                            <b>{{ __('start') }}</b
                            >:
                            {{ moment(routeTimeline.recap.start_date, 'UTC').format('L HH:mm:ss') }}
                        </div>
                        <reverse-geocoding
                            class="reverse-address"
                            :full="true"
                            :latLon="routeTimeline.recap.extremes[0]"
                        />
                        <div class="mt-3">
                            <b>{{ __('end') }}</b
                            >:
                            {{ moment(routeTimeline.recap.end_date, 'UTC').format('L HH:mm:ss') }}
                        </div>
                        <reverse-geocoding
                            class="reverse-address"
                            :full="true"
                            :latLon="routeTimeline.recap.extremes[1]"
                        />
                        <div class="mt-3">
                            <b>{{ __('duration') }}</b
                            >: {{ parseInt(routeTimeline.recap.duration) | minutesToTime }} h
                        </div>
                        <div v-if="routeTimeline.recap.distance">
                            <b>{{ __('distance') }}</b
                            >: {{ routeTimeline.recap.distance.toFixed(2) }} Km
                        </div>
                        <div v-if="routeTimeline.recap.gps_distance">
                            <b>{{ __('gps_distance') }}</b
                            >: {{ routeTimeline.recap.gps_distance.toFixed(2) }} Km
                        </div>
                        <div v-if="routeTimeline.recap.fuel_consumption" class="d-none">
                            <b>{{ __('fuel_consumption') }}</b
                            >: {{ routeTimeline.recap.fuel_consumption.toFixed(2) }} l
                        </div>
                    </div>
                </div>
            </section>
        </VueHtml2pdf>

        <div class="chart-map">
            <activity-chart
                class="activity-chart"
                :layers="layers"
                :activities="activities"
                :extremes="extremes"
                ref="activityChart"
                v-if="$mq !== 'xs' && $mq !== 'sm'"
            />
            <geofleet-map
                class="geofleet-map smaller-controls"
                :map="this.map.map"
                :advanced="this.map.advanced"
                :cluster="this.map.cluster"
                :ptvToken="this.$env.ptv_password"
                :trucks="trucks"
                :noAutoCenterMap="($mq != 'xs' && $mq != 'sm') || showRouteAction"
                :minimal="$mq == 'xs' || $mq == 'sm'"
                :gestureHandling="$mq == 'xs' || $mq == 'sm'"
                ref="map"
            >
                <l-geo-json
                    @ready="geoJsonLoaded"
                    v-for="opt in geojson"
                    :key="opt.id"
                    :geojson="opt.geojson"
                    :optionsStyle="opt.style || {}"
                    :options="opt.options || {}"
                    :ref="'geojson_' + opt.id"
                />
                <!-- Start and Finish markers -->
                <custom-marker
                    id="start"
                    v-if="routeTimeline?.recap?.extremes"
                    :coordinates="routeTimeline?.recap?.extremes[0]"
                    :markerTitle="__('start')"
                    :iconUnicode="'#xf11e'"
                    :customizer="{ tiny: true, color_class: 'start' }"
                />

                <custom-marker
                    id="end"
                    v-if="routeTimeline?.recap?.extremes"
                    :coordinates="routeTimeline?.recap?.extremes[1]"
                    :markerTitle="__('finish_point')"
                    :iconUnicode="'#xf11e'"
                    :customizer="{ tiny: true, color_class: 'finish' }"
                />
            </geofleet-map>
        </div>

        <div class="timeline-wrapper" v-if="layers.length">
            <div class="timeline-tools">
                <div class="container-fluid">
                    <div class="px-0 px-md-4">
                        <div class="row">
                            <div :class="timeline_separator == 0 ? 'col-lg-6' : 'col-12'">
                                <golia-input
                                    v-model.number="timeline_separator"
                                    type="select"
                                    :options="[{ value: 0, text: __('break') }]"
                                />
                            </div>
                            <div class="col-lg-6" v-if="timeline_separator == 0">
                                <golia-input
                                    v-model.number="timeline_break"
                                    type="number"
                                    :min="1"
                                    :max="60"
                                    :step="1"
                                    :placeholder="__('minutes')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="timeline custom-scrollbar">
                <timeline
                    :range="range"
                    :truck="truck"
                    :break="timeline_break"
                    :type="timeline_separator"
                    :showRouteAction="showRouteAction"
                    v-model="routeTimeline"
                    ref="timeline"
                    @selected="timelineSelected"
                    @reset="reset"
                    @print="print"
                />
            </div>
        </div>
    </div>
</template>

<script>
import L from 'leaflet'

import { LGeoJson } from 'vue2-leaflet'
import ActivityChart from './ActivityChart.vue'
import Timeline from './Timeline.vue'
import Spinner from 'vue-simple-spinner'

import { SimpleMapScreenshoter } from 'leaflet-simple-map-screenshoter'
import VueHtml2pdf from 'vue-html2pdf'

import { mapState } from 'vuex'

export default {
    name: 'MapRouteAnalizer',
    props: {
        truck: {
            type: Object,
            required: true
        },
        map: {
            type: Object,
            default: () => {
                return {
                    map: 'silica',
                    advanced: true,
                    cluster: true
                }
            }
        },
        range: {
            type: Object,
            required: false
        },
        timeline: {
            type: Object,
            selected: true
        },
        showRouteAction: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LGeoJson,
        ActivityChart,
        Timeline,
        Spinner,
        VueHtml2pdf
    },
    data() {
        return {
            geojson: [],

            layers: [],
            activities: [],
            stops: [],

            extremes: null,

            ends: { start: null, end: null },
            counter: 0,

            screenShooter: null,
            screenshot: null,
            loadingPrint: false,

            timeline_separator: 0,
            timeline_break: 15,
            routeTimeline: {}
        }
    },
    created() {
        // Se è da mobile non precarico il percorso di default, ma aspetto un azione esplicita
        if (this.$mq != 'xs' && this.$mq != 'sm') {
            this.draw()
        }

        if (this.config) {
            this.timeline_separator = this.config.timeline_separator || 0
            this.timeline_break = this.config.timeline_break || 15
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.map.lmap)
                this.screenShooter = new SimpleMapScreenshoter().addTo(this.$refs.map.lmap)
        })
    },
    watch: {
        showRouteAction() {
            if (this.showRouteAction) this.draw()
            else {
                this.reset()
                this.routeTimeline = {}
                this.geojson = []
                this.layers = []
                this.extremes = null
                this.activities = []
                this.stops = []

                if (this.$refs.map.lmap)
                    this.$refs.map.lmap.setView(
                        [this.truck?.lastpoint?.lat, this.truck?.lastpoint?.lng],
                        13
                    )
            }
        },
        truck: {
            handler(newT, oldT) {
                if (newT.id == oldT.id) return null

                this.draw()
            },
            deep: true
        },
        range: {
            handler() {
                this.draw()
            },
            deep: true
        },
        timeline_break() {
            this.$store.dispatch('saveConfig', {
                timeline_break: this.timeline_break,
                vueInstance: this
            })

            this.drawStops()
        },
        timeline_separator() {
            this.$store.dispatch('saveConfig', {
                timeline_separator: this.timeline_separator,
                vueInstance: this
            })
        }
    },
    computed: {
        trucks() {
            return [this.truck]
        },
        startDate() {
            return this.range.start ? this.range.start.clone().utc().toISOString() : false
        },
        endDate() {
            return this.range.end ? this.range.end.clone().utc().toISOString() : false
        },
        computedStops() {
            if (this.routeTimeline) {
                return this.routeTimeline.timeline.filter((element) => {
                    return element.type == 'stop'
                })
            } else {
                return []
            }
        },
        loading() {
            return this.counter > 0 || this.loadingPrint
        },
        ...mapState({
            config: (state) => state.geoFleet.config
        })
    },
    methods: {
        reset() {
            this.layers.map((layer) => {
                layer.original_style ? layer.setStyle(layer.original_style) : null
            })

            let map_bounds = this.$refs.geojson_route[0].mapObject.getBounds()

            if (map_bounds.isValid()) this.$refs.map.lmap.fitBounds(map_bounds)

            this.extremes = null
        },
        timelineSelected(info) {
            info.bound = info.bound || this.$refs.geojson_route[0].mapObject.getBounds()

            if (info.bound) this.$refs.map.lmap.fitBounds(info.bound)

            this.extremes = info.range

            this.layers.map((layer) => {
                layer.original_style ? layer.setStyle(layer.original_style) : null

                if (
                    info.range &&
                    layer.feature.properties.timestamp * 1000 >= info.range[0] &&
                    layer.feature.properties.timestamp * 1000 <= info.range[1]
                ) {
                    layer.original_style = {
                        weight: layer.options.weight,
                        color: layer.options.color
                    }

                    layer.setStyle({
                        weight: 12,
                        color: '#ff8306'
                    })
                }
            })
        },
        geoJsonLoaded() {
            this.counter -= 1

            if (this.counter <= 0) {
                this.activities = Object.values(this.$refs.geojson_activities[0].mapObject._layers)
                this.stops = Object.values(this.$refs.geojson_stops[0].mapObject._layers)
                this.layers = Object.values(this.$refs.geojson_route[0].mapObject._layers)

                let map_bound = this.$refs.geojson_route[0].mapObject.getBounds()

                if (map_bound.isValid()) this.$refs.map.lmap.fitBounds(map_bound)
            }
        },
        draw() {
            if (!(this.range.start && this.range.end)) return false

            this.geojson = []
            this.counter = 3

            this.drawRoute()
            this.drawStops()
            this.drawActivities()
        },
        drawRoute() {
            let lastpoint_company = this.truck?.lastpoint?.company

            this.$fetch(
                this.$env.GOLIA_API +
                    '/geofleet/trucks/' +
                    this.truck.id +
                    '/route.json?start_date=' +
                    this.startDate +
                    '&end_date=' +
                    this.endDate +
                    '&company=' +
                    lastpoint_company
            )
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    this.ends = {
                        start: res.features.at(0),
                        end: res.features.at(-1)
                    }

                    this.geojson.push({
                        id: 'route',
                        geojson: res,
                        style: (feature) => {
                            let speed = parseInt(
                                feature.properties.tacho_speed || feature.properties.speed
                            )

                            let color = '#fd3030'

                            if (speed <= 30) color = '#5d8dc8' // Blue soft
                            else if (speed <= 50) color = '#5d8dc8' // Blue soft
                            else if (speed <= 70) color = '#5d8dc8' // Blue soft
                            else if (speed <= 90) color = '#335e94' // Blue middle
                            else if (speed <= 100) color = '#335e94' // Blue middle
                            else if (speed <= 130) color = '#fda030' // Orange
                            else color = '#fd3030'

                            return {
                                weight: 7,
                                color: color,
                                opacity: 1
                            }
                        },
                        options: {
                            onEachFeature: (feature, layer) => {
                                layer.on('mouseover', function () {
                                    this.original_style = {
                                        weight: this.options.weight,
                                        color: this.options.color
                                    }

                                    this.setStyle({
                                        weight: 14,
                                        color: '#35bdfc'
                                    })
                                })

                                layer.on('mouseout', function () {
                                    if (this.original_style) this.setStyle(this.original_style)
                                })

                                layer.on('click', function () {
                                    console.log('click')
                                })

                                let date = this.moment(feature.properties.date, 'UTC')
                                let speed =
                                    feature.properties.tacho_speed || feature.properties.speed
                                let heading = feature.properties.heading
                                let altitude = feature.properties.altitude

                                feature.properties.timestamp = date.unix()

                                let tooltip =
                                    '<div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">'
                                tooltip +=
                                    '<div style="display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 5px;">'

                                if (heading)
                                    tooltip +=
                                        '<div style="flex-grow: 2;"><svg style="height: 22px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 595 615"><g style="transform: rotate(' +
                                        String(heading) +
                                        'deg); transform-origin: center;"><path d="M267.6,83.5,113,499c-17.7,48.1,41.3,85.5,76.5,50.6L310.3,429.5l120,120.9c34.9,35.1,94.2-1.9,76.8-50.1L355.2,83.8C340,46.5,283,46.3,267.6,83.5Z" transform="translate(-10 -25)"/></g></svg></div>'

                                tooltip +=
                                    '<div style="display: flex;flex-direction: column;justify-content: flex-start;">'

                                if (speed) tooltip += '<span>' + speed + ' km/h</span>'

                                if (altitude) tooltip += '<span>' + altitude + ' m s.l.m.</span>'

                                tooltip += '</div>'
                                tooltip += '</div>'
                                tooltip += '<span>' + date.format('L HH:mm:ss') + '</span>'
                                tooltip += '</div>'

                                layer.bindTooltip(tooltip, {
                                    direction: 'right',
                                    offset: L.point(10, -40)
                                })
                            }
                        }
                    })
                })
        },
        drawStops() {
            this.$fetch(
                this.$env.GOLIA_API +
                    '/geofleet/trucks/' +
                    this.truck.id +
                    '/stops.json?start_date=' +
                    this.startDate +
                    '&end_date=' +
                    this.endDate
            )
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    let stopsIndex = this.geojson.findIndex((g) => g.id == 'stops')

                    if (stopsIndex >= 0) this.geojson.splice(stopsIndex, 1)

                    var stopsCount = 1

                    res.features = res.features
                        .filter((s) => s.properties.DURATION >= (this.timeline_break || 15))
                        .map((f) => {
                            f.stopsCount = stopsCount++

                            return f
                        })

                    this.geojson.push({
                        id: 'stops',
                        geojson: res,
                        options: {
                            pointToLayer: (feature, latlng) => {
                                const stopMarker = L.marker(latlng, {
                                    icon: L.divIcon({
                                        //html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16"><defs><linearGradient id="myGradient"><stop offset="0%" stop-color="rgba(37,145,251,0.98)" /><stop offset="90%" stop-color="rgba(0,7,128,1)" /></linearGradient></defs><path stroke="white" stroke-width="0.4" d="M14.3,6.5a4.8,4.8,0,0,0-.7-2.3l.5-.5a.7.7,0,0,0,0-.9.7.7,0,0,0-1,0l-.4.4a5.2,5.2,0,0,0-2-.9V1.6H11a.6.6,0,0,0,.6-.6A.7.7,0,0,0,11,.3H9a.7.7,0,0,0-.6.7.6.6,0,0,0,.6.6h.3v.7A4.3,4.3,0,0,0,5.7,6.5a4.8,4.8,0,0,0,.4,1.8h0L10,15.7l3.9-7.4h0A4.8,4.8,0,0,0,14.3,6.5ZM9.5,4.2a.5.5,0,0,1,1,0V6.9a.5.5,0,0,1-1,0Z" fill="url(#myGradient)"/><text fill="#fff" style="font-size: 6px;font-weight: 700;transform: translate(8px, 9px);">' + stopsCount + '</text></svg>',
                                        html:
                                            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386 512"><path fill="rgb(247, 59, 94)" stroke="#fff" stroke-width="30" d="M187.733 505.173L112.64 375.467c-3.413-6.827-6.827-10.24-13.653-17.067l-81.92-78.507C6.827 269.653 0 256 0 242.347V143.36c0-13.653 6.827-27.307 17.067-37.547l88.746-88.746C116.053 6.827 129.707 0 143.36 0h95.573c13.654 0 27.307 6.827 37.547 17.067l88.747 88.746c10.24 10.24 17.066 23.894 17.066 37.547v95.573c0 13.654-6.826 27.307-17.066 37.547l-81.92 81.92c-6.827 6.827-10.24 13.653-13.654 20.48L194.56 505.173c3.413 6.827-6.827 6.827-6.827 0z" class=""></path><text fill="#fff" x="' +
                                            (feature.stopsCount > 10 ? '20%' : '35%') +
                                            '">' +
                                            feature.stopsCount +
                                            '</text></svg>',
                                        className: 'stop-icon stop-icon-' + feature.stopsCount,
                                        iconSize: [26, 35],
                                        iconAnchor: [13, 35]
                                    })
                                })

                                stopMarker.stopIndex = feature.stopsCount
                                stopMarker.extremes = [latlng, latlng]

                                stopMarker.on('click', this.stopMarkerClick)

                                return stopMarker
                            }
                        }
                    })
                })
        },
        drawActivities() {
            this.$fetch(
                this.$env.GOLIA_API +
                    '/geofleet/trucks/' +
                    this.truck.id +
                    '/activities.json?start_date=' +
                    this.startDate +
                    '&end_date=' +
                    this.endDate
            )
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    this.geojson.push({
                        id: 'activities',
                        geojson: res,
                        options: {
                            pointToLayer: function (feature, latlng) {
                                let html = ''

                                if (feature.properties.activity == 0)
                                    html =
                                        '<svg id="Livello_2" data-name="Livello 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16"><path stroke="black" stroke-width="3%" d="M17.2,7.2V9h0v5.2H15.3V9.1H4.9v5.2H3V2H4.9V7.2Z" fill="#ABDDA9"/></svg>'

                                if (feature.properties.activity == 2)
                                    html =
                                        '<svg id="Livello_2" data-name="Livello 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16"><path stroke="black" stroke-width="3%" d="M13.8,14l.2.2h.5l.5-.5.3-.4c.3-.4.3-.6,0-.9L11.6,8.7l1.8-1.9,1.7,1.7.3.3a.8.8,0,0,0,1-.2h0a17.3,17.3,0,0,0,.3-3.2L13.2,1.8h-.5L11,3.7a.6.6,0,0,0,.1.7l.6.7c-.6.6-1.1,1.2-1.7,1.7L8.3,5.1l.6-.6c.3-.4.3-.7,0-1L7.4,2l-.2-.2H6.8L3.2,5.4a11,11,0,0,0,.4,3.1.5.5,0,0,0,.5.5l.4-.2,1-.9A5.7,5.7,0,0,1,6.6,6.8,15.4,15.4,0,0,0,8.3,8.7L4.7,12.4a.6.6,0,0,0-.1.9l.8.9h.7l3.8-3.8H10Z" fill="#FC9E43"/></svg>'

                                return L.marker(latlng, {
                                    icon: L.divIcon({
                                        html: html,
                                        className: '',
                                        iconSize: [26, 18],
                                        iconAnchor: [13, 9]
                                    })
                                })
                            }
                        }
                    })
                })
        },
        resized(rect) {
            let width = (rect.width / 100) * 70

            if (this.$refs.activityChart && this.$refs.activityChart.charts)
                this.$refs.activityChart.charts.map((c) => c.setSize(width, undefined, false))

            if (this.$refs.map && this.$refs.map.lmap) this.$refs.map.lmap.invalidateSize(true)
        },
        print() {
            this.loadingPrint = true

            let format = 'image' // 'image' - return base64, 'canvas' - return canvas
            let overridedPluginOptions = {
                mimeType: 'image/png'
            }

            this.screenShooter
                .takeScreen(format, overridedPluginOptions)
                .then((blob) => {
                    this.screenshot = blob
                    // FileSaver.saveAs(blob, 'screen.png')

                    this.$refs.html2Pdf.generatePdf()

                    this.loadingPrint = false
                })
                .catch((e) => {
                    console.error(e)
                    this.loadingPrint = false
                })
        },
        stopMarkerClick(e) {
            var segment = this.computedStops[e.sourceTarget.stopIndex - 1]

            if (!segment) return null

            var range = [
                this.moment(segment.start_date).unix() * 1000,
                this.moment(segment.end_date).unix() * 1000
            ]

            var bound = e.sourceTarget.extremes

            this.timelineSelected({ bound: bound, range: range })

            // Deseleziono le altre
            this.routeTimeline.timeline.map((segment) => {
                segment.selected = false
            })

            // Seleziono il segmento
            this.routeTimeline.timeline.find((t) => {
                return t.start_date == segment.start_date
            }).selected = true
        }
    }
}
</script>

<style>
.stop-icon text {
    transform: translateY(260px);
    font-size: 190px;
    font-weight: 700;
}
</style>

<style scoped>
.btn-print {
    margin-right: 20px;
}
.route-analyzer {
    height: 100%;
    position: relative;
}
.chart-map {
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    flex-basis: 70%;
}
.activity-chart {
    flex-basis: 30%;
}
.geofleet-map {
    flex-basis: 70%;
}

.timeline-wrapper {
    display: flex;
    flex-direction: column;
    flex-basis: 30%;
}
.timeline {
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* flex-basis: 30%; */
}
.timeline-tools ::v-deep(.form-select),
.timeline-tools ::v-deep(.form-control) {
    color: #333;
}
.timeline-content {
    cursor: pointer;
}
.timeline-content:hover {
    background-color: #edf3f9;
}
.pick-a-date {
    flex-grow: 2;
    justify-content: center;
    align-items: center;
    display: flex;
}
</style>
